module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/part1-5.dd05a01d.png";